import { Component, OnInit } from '@angular/core';
import { ReceiverService } from '../../services/receiver.service';
import { InvoicingServiceDataService } from '../../services/invoicing-service-data.service';
import { IInvoicingServiceData } from '../../model/invoicing-service-data';
import { forEach } from '@angular/router/src/utils/collection';
import { IApplication } from '../../model/application';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-pub-invoicing-services-list',
  templateUrl: './pub-invoicing-services-list.component.html',
  styleUrls: ['./pub-invoicing-services-list.component.css']
})
export class PubInvoicingServicesListComponent implements OnInit {

  /**
   *
   * @type {boolean}
   */
  viewDetails: boolean[] = [];

  /**
   * List of IApplication
   */
  applicationList: IApplication[] = [];

  /**
   * List of IInvoicingServiceData
   */
  invoicingServiceDataList: IInvoicingServiceData[] = [];

  constructor(private invoicingServiceDataService: InvoicingServiceDataService,
              private applicationService: ApplicationService) { }

  ngOnInit() {
    this.invoicingServiceDataService.getInvoicingServicesData()
      .subscribe(result => {
        this.invoicingServiceDataList = result;
        for (let isd of this.invoicingServiceDataList) {
          this.viewDetails[isd.invoicingService.identifier] = false;
        }
      });
    this.applicationService.getApplications().subscribe(result => {
      this.applicationList = result;
    });
  }

  onInvoicingServiceDataClicked(invoicingServiceIdentifier: string) {
    this.viewDetails[invoicingServiceIdentifier] = !this.viewDetails[invoicingServiceIdentifier];
  }

  getCardClass(invoicingServiceIdentifier: string): string {
    return this.viewDetails[invoicingServiceIdentifier] ? 'card-flip activo ': 'card-flip';
  }

  getApplicationClass(applicationName: string): string {
    return 'fa-' + applicationName;
  }

  getApplicationTitle(applicationName: string): string {
    return 'pub.listComponent.titles.' + applicationName;
  }

  getApplicationlabel(applicationName: string): string {
    return 'pub.listComponent.label.' + applicationName;
  }
}



// WEBPACK FOOTER //
// ./src/app/app-public/pub-invoicing-services-list/pub-invoicing-services-list.component.ts